import { ISnListQueryParameters } from './list-query-parameters.interface';

export interface ISnFeedQueryParameters extends ISnListQueryParameters {
  startFrom: string;
  count: number;
}
